import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { complianceAPI } from '@/api';
import type {
  BaseRequest,
  CustomerStatsResponse,
  CustomerCategoryStatsResponse,
  CategoryStatRow,
} from '@/api';
import {
  complianceCategoryStatsActions,
  complianceStatsActions,
} from '@/redux/actions';
import { complianceDataMappers } from '@/redux/mappers';

function* fetchCustomerStats(action: PayloadAction<BaseRequest>): SagaIterator {
  try {
    const { payload } = action;
    const response: CustomerStatsResponse = yield call(
      complianceAPI.getCustomerStats,
      payload,
    );
    const data = complianceDataMappers.fetchCustomerStats(response);
    yield put(complianceStatsActions.setData(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(complianceStatsActions.setLoading(false));
  }
}

function* fetchStatsByCategory(
  action: PayloadAction<BaseRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: CustomerCategoryStatsResponse = yield call(
      complianceAPI.getCustomerCategoryStats,
      payload,
    );

    const data: CategoryStatRow[] =
      complianceDataMappers.fetchStatsByCategory(response);

    yield put(complianceCategoryStatsActions.setData(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(complianceCategoryStatsActions.setLoading(false));
  }
}

export { fetchCustomerStats, fetchStatsByCategory };
